


































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import PrestadorAutocomplete from "@/components/saude/PrestadorAutocomplete.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { PaginationModel } from "@/models/commons/PaginationModel";
import { PrestadorModel } from "@/models/cadastros/assistencia/PrestadorModel";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import { ValidationObserver } from "vee-validate";
import { cadastroAgendaService } from "@/service/cadastro/saude/agenda/CadastroAgendaService";
import { ConfiguracaoAgendaPrestadorPaginationModel } from '@/models/cadastros/saude/ConfiguracaoAgendaPrestadorPaginationModel';
import { CadastroAgendaPrestadorResumidoModel } from '@/models/cadastros/saude/CadastroAgendaPrestadorResumidoModel';
import { ProfissionalModel } from '@/models/cadastros/saude/ProfissionalModel';
import { CadastroAgendaProfissionalResumidoModel } from '@/models/cadastros/saude/CadastroAgendaProfissionalResumidoModel';
import { ConfiguracaoAgendaProfissionalPaginationModel } from '@/models/cadastros/saude/ConfiguracaoAgendaProfissionalPaginationModel';
import { configuracaoAgendaSaudeStore } from '@/store/cadastros/saude/ConfiguracaoAgendaSaudeStore';
import { CadastroPrestadorModel } from '@/models/cadastros/saude/CadastroPrestadorModel';

@Component({
  components: {
    PrestadorAutocomplete,
    GsModalDialog
  },
})
export default class ListaConfiguracaoAgendaPrestador extends Vue {
  @Ref()
  filtroObserver!: InstanceType<typeof ValidationObserver>;

  prestador = "";
  especialidade = "";
  loadingFiltrar = false;
  loading = false;
  prestadorSelecionado: PrestadorResumidoModel = {} as PrestadorResumidoModel;
  prestadores = [];
  profissionaisPrestador: ProfissionalModel[] = [];
  profissionaisFiltrados: ProfissionalModel[] = [];
  profissionalSelecionado: ProfissionalModel = { especialidades: [] };
  nomeProfissional = "";
  loadingProfissional = false;


  configuracaoesAgendaProfissional: CadastroAgendaProfissionalResumidoModel[] = [];

  cabecalho = [
    { text: "Prestador", value: "nomePrestador", sortable: false, width: "30%" },
    { text: "Profissional", value: "nomeProfissional", sortable: false },
    { text: "Duração", value: "duracaoAtendimento", sortable: false, width: "30%" },
    { text: "Ações", value: "actions", sortable: false, width: "10%" },
  ];
  options: PaginationModel = {
    page: 1,
    itemsPerPage: 5,
    itemsLength: 0,
  };

  configuracaoExclusao = {} as CadastroAgendaProfissionalResumidoModel;
  confirmacaoExclusao = false;
  mensagem = "";
  title = "";
  confirmacao = false;

  created() {
    configuracaoAgendaSaudeStore.RESET();
  }

  @Watch("nomeProfissional")
  filtrarProfissional(val: string) {
    this.profissionaisFiltrados = this.profissionaisPrestador.filter(
      (profissional) => {
        if (
          profissional.nome &&
          profissional.nome.toLowerCase().includes((val || "").toLowerCase())
        ) {
          return profissional;
        }
      }
    );
  }

  @Watch("prestadorSelecionado")
  selecionarPrestador(val: PrestadorResumidoModel) {
    cadastroPrestadorService.obterPrestador(val.id).then((res) => {
      this.profissionaisPrestador = res.profissionaisPrestador;
    });
  }

  filtrar() {
    let valid = true;
    if (!this.prestadorSelecionado || !this.prestadorSelecionado.id) {
      this.filtroObserver.setErrors({
        Prestador: "O campo Prestador é obrigatório",
      });
      valid = false;
    }
    if(!valid) {
      return;
    }

    cadastroAgendaService.consultarAgendaProfissional(
      this.options,
      this.prestadorSelecionado.id || 0,
      this.profissionalSelecionado.id
    )
    .then((res: ConfiguracaoAgendaProfissionalPaginationModel) => {
      configuracaoAgendaSaudeStore.SET_PRESTADOR_SELECIONADO(this.prestadorSelecionado);
      this.options.itemsLength = res.itemsLength;
      this.configuracaoesAgendaProfissional = res.conteudo;
    })
    ;
  }

  solicitarExclusao(configuracao: CadastroAgendaProfissionalResumidoModel) {
    this.mensagem = `Confirma a exclusão da agenda do profissional ${configuracao.nomeProfissional}?`;
    this.title = "Confirma exclusão?";
    this.confirmacaoExclusao = true;
    this.configuracaoExclusao = configuracao;
    this.confirmacao = true;
  }

  cancelarExclusao() {
    this.mensagem = "";
    this.title = "";
    this.confirmacaoExclusao = false;
    this.configuracaoExclusao = {} as CadastroAgendaProfissionalResumidoModel;
  }

  confirmarExclusao() {
    this.confirmacaoExclusao = false;
    cadastroAgendaService.excluirConfiguracaoAgendaProfissional(this.configuracaoExclusao.id)
    .then(() => {
      this.title = "Sucesso";
      this.mensagem = `Exclusão da configuração da agenda do profissional ${this.configuracaoExclusao.nomeProfissional} efetuada com sucesso.`;
    })
    .catch(() => {
      this.title = "Erro";
      this.mensagem = `Ocorreu um erro ao excluir a configuração da agenda do proissional ${this.configuracaoExclusao.nomeProfissional}.`;
    })
    .finally(() => {
      this.confirmacao = false;
      this.confirmacaoExclusao = true;
    })
  }

  fecharMensagem() {
    this.mensagem = "";
    this.title = "";
    this.confirmacaoExclusao = false;
    this.configuracaoExclusao = {} as CadastroAgendaProfissionalResumidoModel;
    this.filtrar();
  }
  
}
